<template>
  <cumulus-action-dialog
    ref="dialog"
    v-model="dialogInfo"
    icon="$info"
    :title="$t('organization_guest_apply')"
    action-text="sending"
    color="info"
    activator-button
    @escape="closeDialog"
    @start="start"
  >
    <template v-slot:info>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <data-selector
              v-model="organization_id"
              field-name="organization"
              label="organization"
              source-type="organizations"
            />
          </v-col>
          <v-col cols="12">
            <data-selector
              v-model="user_id"
              :disabled="type !== 'organization'"
              field-name="user_id"
              label="pilot"
              source-type="pilots"
              rules=""
            />
          </v-col>
          <v-col
            v-if="type === 'organization'"
            cols="12"
          >
            <data-selector
              v-model="plane_id"
              field-name="reg_num"
              source-type="planes"
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <date-field
              v-model="start_date"
              field-name="range_start_date"
              rules="required|date"
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <date-field
              v-model="end_date"
              field-name="range_end_date"
              rules="required|date"
            />
          </v-col>
        </v-row>
      </v-card-text>
    </template>
  </cumulus-action-dialog>
</template>

<script>

  import { call, get } from 'vuex-pathify'

  export default {
    name: 'ActionUserOrganizationGuestApply',
    props: {
      type: {
        type: String,
        default: 'profile',
      },
    },
    data () {
      return {
        dialogInfo: false,
        organization_id: null,
        user_id: null,
        plane_id: null,
        start_date: null,
        end_date: null,
      }
    },
    computed: {
      profile: get('auth/profile'),
    },
    watch: {
      dialogInfo (val) {
        val || this.closeDialog()
      },
    },
    mounted () {
      this.user_id = this.profile.user_id
      /* UploadService.getFiles().then((response) => {
        this.fileInfos = response.data
      }) */
    },
    methods: {
      sendOrganizationGuestApply: call('action/userOrganizationGuestApply'),
      async start () {
        console.log(this.organization_id)
        await this.sendOrganizationGuestApply(
          {
            organization_id: this.organization_id,
            user_id: this.user_id,
            plane_id: this.plane_id,
            start_date: this.start_date,
            end_date: this.end_date,
          },
        ).then(response => {
          console.log('apply success')
          this.closeDialog()
        }).catch(e => {
          console.log(e)
          this.$refs.dialog.setErrors(e)
        })
      },
      closeDialog () {
        this.dialogInfo = false
      },
    },
  }
</script>

<style lang="sass">
.v-dialog
  .v-card
    display: flex !important
    flex-direction: column

  .v-card__text
    flex-grow: 1
    overflow: auto
// max-height: calc(100vh - 500px)
</style>
